// ======================================================
// 📂 DATOS PARA EL COMPONENTE EVIDENCIAS
// ======================================================

const cievidenciasitems = {

  // =========================================
  // 🖼️ IMAGEN DE FONDO (puede ser patrón)
  // =========================================
  background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/MSCI_001.png",


  // =========================================
  // 🔗 LINKS SUPERIORES
  // =========================================
  links: [
    { texto: "Inicio", url: "/Cinterno" },
    { texto: "Metodología", url: "/Cinterno/Metodologia" },
    { texto: "Componentes de Control", url: "/Cinterno/Control" },
    { texto: "Organigrama", url: "/Cinterno/Organigrama" },
    { texto: "Evidencias", url: "/Cinterno/Evidencias" }
  ],


  // =========================================
  // 📝 CUADRO DE TEXTO
  // =========================================
  cuadroTexto: {
    titulo: "Evidencias Documentales",
    descripcion: `
      En esta sección se presentan las evidencias documentales del programa.
      <br /><br />
      Cada apartado contiene archivos en formato PDF que pueden ser consultados
      y descargados para su revisión.
    `
  },


  // =========================================
  // 📂 ESTRUCTURA DEL ACORDEÓN
  // =========================================
  acordeon: [

    // 🔹 SECCIÓN 1
    {
      titulo: "Comité de Control Interno de la SEBISO",
      archivos: [
        {
          nombre: "2026 Cuarta Sesión Ordinaria del Comité de Control y Desempeño Institucional",
          url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/EF_4taSOrd_2026.pdf"
        },
         {
          nombre: "2026 Tercera Sesión Ordinaria del Comité de Control y Desempeño Institucional",
          url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/EF_3raSOrd_2026.pdf"
        },
        {
          nombre: "2026 Segunda Sesión Ordinaria del Comité de Control y Desempeño Institucional",
          url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/EF_2aSOrd_2026.pdf"
        },
        {
          nombre: "2026 Primera Sesión Extraordinaria del Comité de Control y Desempeño Institucional",
          url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/EF_1aSExtr_2026.pdf"
        },
        {
          nombre: "2026 Primera Sesión Ordinaria del Comité de Control y Desempeño Institucional",
          url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/EF_1aSOrd_2026.pdf"
        },
        {
          nombre: "2025 Cuarta Sesión Ordinaria del Comité de Control y Desempeño Institucional",
          url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/Evidencia_Fotográfica_4TASO_COCODI_2025.pdf"
        },
      ]
    },

    // 🔹 SECCIÓN 2
    {
      titulo: "Programa de Trabajo de Control Interno",
      archivos: [
        
        {
          nombre: "2026 PTCI",
          url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/PTCI_2026.pdf"
        },
        {
          nombre: "2025 PTCI",
          url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/PTCI_2025_V01_MicS.pdf"
        },
        {
          nombre: "2024 PTCI",
          url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/PTCI_2024.pdf"
        }
      ]
    },

    // 🔹 SECCIÓN 3
    {
      titulo: "Programa de Administración de Riesgos",
      archivos: [
        {
          nombre: "2026 PTAR",
          url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/PTAR_2026.pdf"
        },
        {
          nombre: "2025 PTAR",
          url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/PTAR_2025.pdf"
        },
        {
          nombre: "2024 PTAR",
          url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/PTAR_2024.pdf"
        }
      ]
    },

    // 🔹 SECCIÓN 4
    {
      titulo: "Informe Anual de Estado que Guarda el Sistema de Control Interno Institucional",
      archivos: [
        {
          nombre: "2024 IA_SCII",
          url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/IA_SCII_2024.pdf"
        },
        {
          nombre: "2023 IA_SCII",
          url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/IA_SCII_2023.pdf"
        }
      ]
    },

    // 🔹 SECCIÓN 4
    {
      titulo: "Reporte Anual de Comportamiento de Riesgos",
      archivos: [
        {
          nombre: "2024 RACR",
          url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/RACR_2024.pdf"
        },
        {
          nombre: "2023 RACR",
          url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/RACR_2023.pdf"
        }
      ]
    }

  ]

};

export default cievidenciasitems;